type failureCallbackType = () => string;

export const SessionStorage = {
  setItem: (key: string, value: string): void => {
    try {
      sessionStorage.setItem(key, value);
    } catch (_error) {
      // ignore
    }
  },
  getItem: (
    key: string,
    failureCallback?: failureCallbackType,
  ): string | null => {
    try {
      return sessionStorage.getItem(key);
    } catch (_error) {
      // ignore
    }

    if (failureCallback) {
      return failureCallback();
    }

    return null;
  },
  removeItem: (key: string): void => {
    try {
      sessionStorage.removeItem(key);
    } catch (_error) {
      // ignore
    }
  },
  keys: {
    TALENT_RESUME_UPLOADED: "TALENT_RESUME_UPLOADED",
    NAVIGATE_WITH_SNACKBAR_DATA: "NAVIGATE_WITH_SNACKBAR_DATA",
    FREELANCER_TIMEZONE_UPDATED: "FREELANCER_TIMEZONE_UPDATED",
    POST_USER_EMAIL_VERIFICATION: "POST_USER_EMAIL_VERIFICATION",
  } as const,
};
